<template>
    <vs-row>
        <vs-row vs-justify="space-between" class="my-5 mx-4">
            <input maxLength="30" type="text" name="search" class="search px-4 w-1/4 py-3 shadow-lg"
                placeholder="Search..." @input="handleSearch" v-model="search" />
        </vs-row>

        <vs-row class="tblBgClrAdmin shadow-lg mx-4">
            <vs-row>
                <h3 class="p-5 pb-4">Transaction Edits</h3>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="8" class="pr-8">
                    <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
                        These are the transactions which have been edited by the users. You can view their details to approve or reject them.
                    </p>
                </vs-col>
            </vs-row>
            <vs-table ref="table" v-model="selected" :max-items="itemsPerPage" :data="transactionEditsList"
                class="w-full" hoverFlat>

                <template slot="thead">
                    <vs-th>CREDIT CARD NAME</vs-th>
                    <vs-th>USER NAME</vs-th>
                    <vs-th>PREV CATEGORY</vs-th>
                    <vs-th>CURRENT CATEGORY</vs-th>
                    <vs-th>STATUS</vs-th>
                    <vs-th>DATE</vs-th>
                    <vs-th>ACTION</vs-th> <!-- New Action column -->
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td>
                                <p class="font-medium">{{ tr.userDetails && tr.userDetails.card ? tr.userDetails.card.name : 'NA'}}</p>
                            </vs-td>

                            <vs-td>
                                <p class="font-medium">{{ tr.userDetails  ? `${tr.userDetails.firstname} ${tr.userDetails.lastname}` : 'NA'}}</p>
                            </vs-td>

                            <vs-td>
                                <p class="font-medium">{{ tr.prevPointCategory ? tr.prevPointCategory.name : "NA" }}</p>
                            </vs-td>

                            <vs-td>
                                <p class="font-medium">{{ tr.pointCategory ? tr.pointCategory.name : 'NA'}}</p>
                            </vs-td>

                            <vs-td>
                                <p class="font-medium capitalize">{{ tr.status }}</p>
                            </vs-td>

                            <vs-td>
                                <p class="font-medium">{{ new Date(tr.createdAt).toDateString() }}</p>
                            </vs-td>

                            <vs-td> <!-- New column for actions -->
                                <div>
                                    <vs-button color="primary" @click="viewDetails(tr._id)">
                                        VIEW DETAILS
                                    </vs-button>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <vs-row class="my-6 w-full" vs-justify="center"
                v-if="transactionEditsList && transactionEditsList.length > 0">
                <div style="width:max-content">
                    <vs-pagination :total="totalPages" v-model="pageIndex" @input="handlePageChange"
                        v-show="transactionEditsList && transactionEditsList.length > 0">
                    </vs-pagination>
                </div>
            </vs-row>
        </vs-row>
    </vs-row>
</template>

<script>
export default {
    data() {
        return {
            search: '',
            searchTimeout: null,
            selected: [],
            itemsPerPage: 10,
            transactionEditsList: [],
            totalPages: 0,
            pageIndex: 1,
            initialLoad: true,
        };
    },
    methods: {
        handleSearch() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            
            this.searchTimeout = setTimeout(() => {
                this.getTransactionEdits();
            }, 1000);
        },
        async getTransactionEdits() {
            this.$vs.loading({ background: "rgba(1,2,3,.2)" });
            try {
                const result = await this.$axios.get(`${this.$ApiKeys.BASE_URL}/transactions/admin/edits?perPage=10&page=${this.pageIndex}&limit=${this.itemsPerPage}&keyword=${this.search}`);
                this.transactionEditsList = result.data.data.nodes;
                this.totalPages = Math.ceil(result.data.data.nodesCount / this.itemsPerPage);
                this.$vs.loading.close();
            } catch (error) {
                this.toast(this.genericErrorMessage());
                this.$vs.loading.close();
            }
        },
        async viewDetails(id){
            this.$router.push(`/credit-cards/transaction-edits/${id}`);
        },  
        async updateStatus(id, status) {
            this.$vs.loading({ background: "rgba(1,2,3,.2)" });
            try {
                await this.$axios.patch(`${this.$ApiKeys.BASE_URL}/transactions/admin/edits/${id}?status=${status}`);
                this.$vs.loading.close();
                this.getTransactionEdits(); // Refresh the data after updating the status
            } catch (error) {
                this.$vs.loading.close();
                console.error('Failed to update status', error);
            }
        },
        handlePageChange() {
            if (!this.initialLoad) {
                this.getTransactionEdits();
            }
            this.initialLoad = false;
        },
    },
    mounted() {
        this.getTransactionEdits();
    },
};
</script>

<style>
@import './style.css';
</style>
